/* tslint:disable */
/* eslint-disable */
/**
 * Roles API
 * API for managing user roles
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetCurrentRole401Response,
  GetCurrentRoleResponse,
  GetPortailsResponse,
  SwitchPortailCommand,
  SwitchRoleCommand,
} from '../models/index';
import {
    GetCurrentRole401ResponseFromJSON,
    GetCurrentRole401ResponseToJSON,
    GetCurrentRoleResponseFromJSON,
    GetCurrentRoleResponseToJSON,
    GetPortailsResponseFromJSON,
    GetPortailsResponseToJSON,
    SwitchPortailCommandFromJSON,
    SwitchPortailCommandToJSON,
    SwitchRoleCommandFromJSON,
    SwitchRoleCommandToJSON,
} from '../models/index';

export interface SwitchCurrentPortailRequest {
    switchPortailCommand: SwitchPortailCommand;
}

export interface SwitchCurrentRoleRequest {
    switchRoleCommand: SwitchRoleCommand;
}

/**
 * 
 */
export class RolesApi extends runtime.BaseAPI {

    /**
     * Retrieves the current active role and all available roles for the user
     * Get current role
     */
    async getCurrentRoleRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentRoleResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/roles/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCurrentRoleResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the current active role and all available roles for the user
     * Get current role
     */
    async getCurrentRole(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentRoleResponse> {
        const response = await this.getCurrentRoleRaw(initOverrides);
        return await response.value();
    }

    /**
     * Portail actif + portails accessibles du compte, avec les briques effectives de chacun (mode portail du refacto rôles). estModePortail=false pour un compte legacy sans brique. 
     * Get accessible portals
     */
    async getPortailsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPortailsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/roles/portails`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPortailsResponseFromJSON(jsonValue));
    }

    /**
     * Portail actif + portails accessibles du compte, avec les briques effectives de chacun (mode portail du refacto rôles). estModePortail=false pour un compte legacy sans brique. 
     * Get accessible portals
     */
    async getPortails(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPortailsResponse> {
        const response = await this.getPortailsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Switch du portail actif, par NOM (Codes.Portails). Enforcé côté serveur à chaque requête (ActivePortail relu en base) — effet immédiat, avant même le renew du token. Refus si le portail n\'est pas accessible (briques + garde de gouvernance pour le Portail Plateforme). 
     * Switch current portal
     */
    async switchCurrentPortailRaw(requestParameters: SwitchCurrentPortailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPortailsResponse>> {
        if (requestParameters['switchPortailCommand'] == null) {
            throw new runtime.RequiredError(
                'switchPortailCommand',
                'Required parameter "switchPortailCommand" was null or undefined when calling switchCurrentPortail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/roles/portails/current`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SwitchPortailCommandToJSON(requestParameters['switchPortailCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPortailsResponseFromJSON(jsonValue));
    }

    /**
     * Switch du portail actif, par NOM (Codes.Portails). Enforcé côté serveur à chaque requête (ActivePortail relu en base) — effet immédiat, avant même le renew du token. Refus si le portail n\'est pas accessible (briques + garde de gouvernance pour le Portail Plateforme). 
     * Switch current portal
     */
    async switchCurrentPortail(requestParameters: SwitchCurrentPortailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPortailsResponse> {
        const response = await this.switchCurrentPortailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Switch du rôle actif — enforcé côté serveur à chaque requête (prend effet en base immédiatement, avant même le renew du token). Body { roleName }, insensible à la casse. L\'ancien query param roleId est SUPPRIMÉ (breaking). 
     * Switch current role
     */
    async switchCurrentRoleRaw(requestParameters: SwitchCurrentRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentRoleResponse>> {
        if (requestParameters['switchRoleCommand'] == null) {
            throw new runtime.RequiredError(
                'switchRoleCommand',
                'Required parameter "switchRoleCommand" was null or undefined when calling switchCurrentRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/roles/current`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SwitchRoleCommandToJSON(requestParameters['switchRoleCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCurrentRoleResponseFromJSON(jsonValue));
    }

    /**
     * Switch du rôle actif — enforcé côté serveur à chaque requête (prend effet en base immédiatement, avant même le renew du token). Body { roleName }, insensible à la casse. L\'ancien query param roleId est SUPPRIMÉ (breaking). 
     * Switch current role
     */
    async switchCurrentRole(requestParameters: SwitchCurrentRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentRoleResponse> {
        const response = await this.switchCurrentRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
